var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "magic_svg__icon magic_svg__icon-tabler magic_svg__icon-tabler-wand",
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21L21 6l-3-3L3 18l3 3M15 6l3 3M9 3a2 2 0 002 2 2 2 0 00-2 2 2 2 0 00-2-2 2 2 0 002-2M19 13a2 2 0 002 2 2 2 0 00-2 2 2 2 0 00-2-2 2 2 0 002-2"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb24tdGFibGVyLXdhbmQiIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIgdmlld0JveD0iMCAwIDI0IDI0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+CiAgPHBvbHlsaW5lIHBvaW50cz0iNiAyMSAyMSA2IDE4IDMgMyAxOCA2IDIxIiAvPgogIDxsaW5lIHgxPSIxNSIgeTE9IjYiIHgyPSIxOCIgeTI9IjkiIC8+CiAgPHBhdGggZD0iTTkgM2EyIDIgMCAwIDAgMiAyYTIgMiAwIDAgMCAtMiAyYTIgMiAwIDAgMCAtMiAtMmEyIDIgMCAwIDAgMiAtMiIgLz4KICA8cGF0aCBkPSJNMTkgMTNhMiAyIDAgMCAwIDIgMmEyIDIgMCAwIDAgLTIgMmEyIDIgMCAwIDAgLTIgLTJhMiAyIDAgMCAwIDIgLTIiIC8+Cjwvc3ZnPg==";
export { SvgMagic as ReactComponent };